import { commonRequest } from "../../../services/ApiCall";
import { Helpers } from "../../../services/Helpers";

export const BannerServices = {
    bannerList : async (data)=>{
        console.log("filter Data",data);
        const queryParams = new URLSearchParams();

        // Basic pagination and sorting parameters
        queryParams.append('page', data.page + 1);
        queryParams.append('limit', data.limit);

        // Search parameters
        queryParams.append('searchKey', data.filters.searchKey || '');
        

        // Sorting parameters
        if (data.filters.sortBy) {
            queryParams.append('sortBy', data.filters.sortBy);            
            queryParams.append('sortType', data.filters.sortType || 'desc');
        }
        
        // // Active or not filters
        // queryParams.append('isActive', data.filters?.isActive || '');

        // Additional multi-column filters
        if (data.filters.filterOptions) {
            data.filters.filterOptions.forEach((filter, index) => {
                if (filter.fieldName && filter.value) {
                    queryParams.append(`filters[${index}][fieldName]`, filter.fieldName);
                    queryParams.append(`filters[${index}][operator]`, filter.operator);
                    queryParams.append(`filters[${index}][value]`, filter.value);
                    
                    if (index !== 0) {
                        queryParams.append(`filters[${index}][andOr]`, filter.andOr);
                    }
                    
                    if (filter.operator === 'between') {
                        queryParams.append(`filters[${index}][endValue]`, filter.endValue);                        
                    }
                }
            });
        }
        console.log("queryParams",queryParams.toString());
        return await commonRequest("GET",  `${Helpers.URL()}/api/admin/banner/list?${queryParams.toString()}`,{}, Helpers.token());
    },
    getBannerById : async (id)=>{
        return await commonRequest("GET", `${Helpers.URL()}/api/admin/banner/bannerDetails/${id}`,{}, Helpers.token());
    },
    addBanner : async (data)=>{
        return await commonRequest("POST", `${Helpers.URL()}/api/admin/banner/addBanner`,data, Helpers.token());
    },
    updateBanner : async (id,data)=>{
        return await commonRequest("PUT", `${Helpers.URL()}/api/admin/banner/updateBanner/${id}`,data, Helpers.token());
    },
    changeStatus : async (id)=>{
        return await commonRequest("get", `${Helpers.URL()}/api/admin/banner/modifyStatus/${id}`,{}, Helpers.token());
    },
    updatePositions : async (data) =>{
        return await commonRequest("PUT", `${Helpers.URL()}/api/admin/banner/modify-positions`,data, Helpers.token());
    },
    exportList : async (data) =>{
        console.log("data",data);
        const queryParams = new URLSearchParams();

        // Search parameters
        queryParams.append('searchKey', data.filters.searchKey || '');
        

        // Sorting parameters
        if (data.filters.sortKey) {
            queryParams.append('sortKey', data.filters.sortKey);            
            queryParams.append('sortDirection', data.filters.sortDirection || 'desc');
        }
        

        // Additional multi-column filters
        if (data.filters.filterOptions) {
            data.filters.filterOptions.forEach((filter, index) => {
                if (filter.fieldName && filter.value) {
                    queryParams.append(`filters[${index}][fieldName]`, filter.fieldName);
                    queryParams.append(`filters[${index}][operator]`, filter.operator);
                    queryParams.append(`filters[${index}][value]`, filter.value);
                    
                    if (index !== 0) {
                        queryParams.append(`filters[${index}][andOr]`, filter.andOr);
                    }
                    
                    if (filter.operator === 'between') {
                        queryParams.append(`filters[${index}][endValue]`, filter.endValue);                        
                    }
                }
            });
        }
        console.log("queryParams",queryParams.toString());
        return await commonRequest("get",  `${Helpers.URL()}/api/admin/reward/export-list?${queryParams.toString()}`, {}, Helpers.token());
    },
    getBannerCategoryList  : async (data)=>{ 
        return await commonRequest("GET", `${Helpers.URL()}/api/admin/banner-category/list`,{}, Helpers.token());
    },
    addBannerCategory : async (data)=>{
        return await commonRequest("POST", `${Helpers.URL()}/api/admin/banner-category/add`,data, Helpers.token());
    },
    allValidExperts: async () => {
        return await commonRequest("GET", `${Helpers.URL()}/api/v2/admin/experts/expert-list`, {}, Helpers.token());
    },
    serviceList: async (subCategoryId)=>{
        return await commonRequest("get",  `${Helpers.URL()}/api/v2/admin/service-master/getServicesBySubcategory/${subCategoryId}`,{}, Helpers.token());
        // return await commonRequest("get",  `${Helpers.URL()}/api/admin/service-master/getServicesBySubcategory/${data.subCategoryId}`,{}, Helpers.token());
    },
}